import { Navigate } from "react-router-dom";

import MenuBar from "../layouts/Menubar/index.js";
import AdminLayout from "../layouts/AdminLayout";

import Dashboard from "./Dashboard";
import Analytics from "./Analytics";
import RegisteredOrganization from "./RegisteredOrganization/index.js";
import SuperUser from "./SuperUser";
import Ambassador from "./Ambassador";
import User from "./User";
import Therapist from "./Therapist";
import Notification from "./Notification";
import Embeddings from "./Embeddings";
import BRGPatientPrompt from "./BRGPatientPrompt";
import InAppNotification from "./InAppNotification";
import EmailTemplates from "./EmailTemplate";
import IndiProgram from "./IndiProgram";

import Login from "./Auth/login";
import ResetPassword from "./Auth/reset";

import ErrorLog from "./ErrorLog";
import DailyCronLog from "./DailyCronLog";
import BRGPatientEmailLog from "./BRGPatientEmailLog";
import Settings from "./Settings";
import IndiChallenge from "./IndiChallenge";
import IndiChallengeParticipant from "./IndiChallengeParticipant";
import Prompt from "./Prompt";
import OnboardingPromptPlayground from "./OnboardingPromptPlaygroundV2";
import TherapistReminder from "./TherapistReminder";

import PanelUser from "./PanelUser";
import PanelNotification from "./PanelNotification";
import PanelIndiProgram from "./PanelIndiProgram";
import PanelIndiChallenge from "./PanelIndiChallenge";
import PanelEmail from "./PanelEmail";
import PanelSanbox from "./PanelSanbox";
import PanelCron from "./PanelCron";

export const PUBLIC_ROUTES = [
  {
    path: "/",
    element: <Login />,
  },

  {
    path: "login",
    element: <Login />,
  },

  {
    path: "*",
    element: <Login />,
  },

  {
    path: "reset-password",
    element: <ResetPassword />,
  },
];

export const PRIVATE_ROUTES = [
  //Add your private routes here
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/users-panel/user" />,
      },
      // {
      //   path: "/dashboard",
      //   element: <Dashboard />,
      // },

      {
        path: "/analytics",
        element: <Analytics />,
      },

      {
        path: "/organizations",
        element: <RegisteredOrganization />,
      },

      {
        path: "/super-users",
        element: <SuperUser />,
      },

      {
        path: "/ambassadors",
        element: <Ambassador />,
      },

      {
        path: "/users",
        element: <User />,
      },
      {
        path: "/therapist",
        element: <Therapist />,
      },

      {
        path: "/therapist-reminder",
        element: <TherapistReminder />,
      },

      {
        path: "/notifications",
        element: <Notification />,
      },

      {
        path: "/embeddings",
        element: <Embeddings />,
      },
      {
        path: "/brg-discharged-patients",
        element: <BRGPatientPrompt />,
      },
      {
        path: "/in-app-notifications",
        element: <InAppNotification />,
      },
      {
        path: "/error-logs",
        element: <ErrorLog />,
      },
      {
        path: "/email-templates",
        element: <EmailTemplates />,
      },
      {
        path: "/indi-programs",
        element: <IndiProgram />,
      },
      {
        path: "/daily-cron-logs",
        element: <DailyCronLog />,
      },
      {
        path: "/brg-patient-email-logs",
        element: <BRGPatientEmailLog />,
      },
      {
        path: "/app-settings",
        element: <Settings />,
      },
      {
        path: "/indi-challenges",
        element: <IndiChallenge />,
      },
      {
        path: "/indi-challenge-participants",
        element: <IndiChallengeParticipant />,
      },
      {
        path: "/indi-ai-prompts",
        element: <Prompt />,
      },
      {
        path: "/indi-ai-onboarding-playground",
        element: <OnboardingPromptPlayground />,
      },


      {
        path: "/users-panel/:tab",
        element: <PanelUser />,
      },

      {
        path: "/notifications-panel/:tab",
        element: <PanelNotification />,
      },

      {
        path: "/indi-programs-panel/:tab",
        element: <PanelIndiProgram />,
      },

      {
        path: "/indi-challenges-panel/:tab",
        element: <PanelIndiChallenge />,
      },

      {
        path: "/email-panel/:tab",
        element: <PanelEmail />,
      },

      {
        path: "/sandbox-panel/:tab",
        element: <PanelSanbox />,
      },

      {
        path: "/cron-panel/:tab",
        element: <PanelCron />,
      },
    ],
  },

  {
    path: "*",
    element: <Navigate to="/users-panel/user" />,
  },


];

export const COMPANY_ROUTES = [
  //Add your private routes here
  {
    path: "/",
    element: <AdminLayout />,
    children: [
      {
        path: "/",
        element: <Navigate to="/users-panel/user" />,
      },
      // {
      //   path: "/dashboard",
      //   element: <Dashboard />,
      // },

      {
        path: "/users-panel/:tab",
        element: <PanelUser />,
      },

    ],
  },

  {
    path: "*",
    element: <Navigate to="/" />,
  },

];